import { graphql } from "@opensea/graphql"

export const WalletPositionStatsFragment = graphql(`
  fragment WalletPositionStats on Currency {
    contractAddress
    chain {
      identifier
    }
  }
`)

export const WalletPositionStatsQuery = graphql(`
  query WalletPositionStatsQuery($address: Address!, $contracts: [ContractIdentifierInput!]) {
    addressBalances(address: $address, contracts: $contracts, disableSpamFiltering: true) {
      currency {
        symbol
      }
      usdValue
      quantity
      gainStats {
        invested
        realized
        unrealized
        returnPercentage
        gain
      }
    }
  }
`)
